/* ────────────────────────────────────────────────────────────────
   src/components/Footer.jsx
────────────────────────────────────────────────────────────────── */
import React from "react";
import {
  Box,
  Typography,
  Link,
  IconButton,
  Stack,
  Grid,
  Divider,
} from "@mui/material";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";

/* — Logo blanco — */
import kwLogoWhite from "../assets/logo/kw-logo-conletrablanca.png";

const navLinks = [
  { label: "Inicio", href: "#top" },
  { label: "Quienes somos", href: "#quienes-somos" },
  { label: "Energía Solar", href: "#energia-solar" },
  { label: "Planes de Pago", href: "#planes-pago" },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        color: "#fff",
        pt: { xs: 10, md: 12 },
        pb: { xs: 6, md: 8 },
        background:
          "linear-gradient(140deg,#1a1a1a 0%,#232323 40%,#1b1b1b 100%)",
      }}
    >
      {/* Franja lateral naranja */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 6,
          height: "100%",
          bgcolor: "#E06A00",
        }}
      />

      <Box sx={{ maxWidth: 1150, mx: "auto", px: { xs: 3, md: 4 } }}>
        <Grid
          container
          columnSpacing={{ xs: 4, md: 10 }}
          rowSpacing={6}
          justifyContent="flex-start"
        >
          {/* —— Marca + redes —— */}
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src={kwLogoWhite}
              alt="KW Solar – logotipo"
              sx={{ width: 190, mb: 1 }}
            />

            <Typography
              variant="body2"
              sx={{ opacity: 0.8, maxWidth: 300, mb: 3 }}
            >
              Impulsamos tu transición energética con soluciones solares
              integrales y soporte experto.
            </Typography>

            <Stack direction="row" spacing={1}>
              {[
                { icon: FaFacebookF, href: "#" },
                { icon: FaInstagram, href: "#" },
                { icon: FaTwitter, href: "#" },
                { icon: FaLinkedinIn, href: "#" },
              ].map(({ icon: Icon, href }) => (
                <IconButton
                  key={href}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: 38,
                    height: 38,
                    border: "1px solid rgba(255,255,255,0.3)",
                    transition: "all .25s",
                    "&:hover": {
                      bgcolor: "#E06A00",
                      borderColor: "#E06A00",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <Icon size={14} color="#fff" />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          {/* —— Enlaces —— */}
          <Grid item xs={12} sm="auto" md="auto">
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
              Enlaces
            </Typography>
            <Divider
              sx={{
                width: 32,
                height: 3,
                bgcolor: "#E06A00",
                borderRadius: 2,
                mb: 2.5,
              }}
            />
            {navLinks.map(({ label, href }) => (
              <Link
                key={label}
                href={href}
                underline="none"
                sx={{
                  display: "block",
                  color: "inherit",
                  opacity: 0.75,
                  mb: 0.65,
                  transition: "all .2s",
                  "&:hover": {
                    opacity: 1,
                    pl: 0.6,
                    color: "#E06A00",
                  },
                }}
              >
                {label}
              </Link>
            ))}
          </Grid>

          {/* —— Contacto —— */}
          <Grid item xs={12} sm="auto" md="auto">
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
              Contacto
            </Typography>
            <Divider
              sx={{
                width: 32,
                height: 3,
                bgcolor: "#E06A00",
                borderRadius: 2,
                mb: 2.5,
              }}
            />
            <Typography variant="body2" sx={{ opacity: 0.85, mb: 0.6 }}>
              662&nbsp;143&nbsp;0033
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mb: 0.6 }}>
              info@kwsolar.com
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              Blvd&nbsp;Colosio&nbsp;C.&nbsp;Real&nbsp;del&nbsp;Arco,
              Hermosillo,&nbsp;Sonora,&nbsp;México.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Línea & copy */}
      <Divider
        sx={{
          borderColor: "rgba(255,255,255,0.15)",
          mt: { xs: 8, md: 10 },
          mb: 3,
        }}
      />
      <Typography
        variant="body2"
        align="center"
        sx={{ opacity: 0.55, fontSize: 13 }}
      >
        © {new Date().getFullYear()} KWENERGY · Todos los derechos reservados
      </Typography>
    </Box>
  );
}
